import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import "@/styles/global.css";

// Initialise i18n (ko default, en fallback) before the tree mounts so the
// very first paint already reflects the detected/persisted language.
import "@/shared/i18n";

import { AppProviders } from "@/app/providers";
import { router } from "@/app/router";
import { installServiceWorkerAutoRefresh } from "@/shared/pwa/autoRefresh";

// 배포 뒤 떠 있는 화면이 옛 버전에 머물지 않게 — 새 서비스 워커가 넘겨받으면 한 번 새로 고친다.
installServiceWorkerAutoRefresh();

const root = document.getElementById("root");
if (!root) throw new Error("missing #root");

createRoot(root).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
